import Alert from '@mui/material/Alert';
import { useFormContext } from 'react-hook-form';

function getNodeByPath(obj, path) {
  if (!obj || !path) return undefined;

  return path.split('.').reduce((acc, key) => {
    if (!acc) return undefined;
    return acc[key];
  }, obj);
}

export function extractErrorMessagesFromNode(errors) {
  const messages = [];

  function walk(node) {
    if (!node || typeof node !== 'object') return;

    if (node.message && typeof node.message === 'string') {
      messages.push(node.message);
    }

    for (const key in node) {
      if (typeof node[key] === 'object') {
        walk(node[key]);
      }
    }
  }

  walk(errors);
  return messages;
}

export function ErrorSummary() {
  const {
    formState: { errors },
  } = useFormContext();
  const errorMessages = extractErrorMessagesFromNode(errors);

  if (!errorMessages.length) return null;
  return (
    <Alert severity='error' sx={{ mb: 2 }}>
      <div className='column gap-1'>
        {errorMessages.map((msg, i) => (
          <span key={i}>{msg}</span>
        ))}
      </div>
    </Alert>
  );
}

export function SectionErrorSummary({ name, names = [] }: { name?: string; names?: string[] }) {
  const {
    formState: { errors },
  } = useFormContext();

  let nodes = [];
  if (name) nodes = [getNodeByPath(errors, name)];
  if (Array.isArray(names)) nodes = names.map((n) => getNodeByPath(errors, n));

  const errorMessages = nodes.flatMap((node) => extractErrorMessagesFromNode(node)).filter(Boolean);

  if (!errorMessages.length) return null;

  return (
    <Alert severity='error' sx={{ mb: 2 }}>
      <div className='column gap-1'>
        {errorMessages.map((msg, i) => (
          <span key={i}>{msg}</span>
        ))}
      </div>
    </Alert>
  );
}
